export const reportScheduleGTMTags = {
  reportSchedule: {
    '1': 'Card_Portal_Reports_Reports_Schedule_Account_Fuel_Spend_Summary_Run_Report',
    '2': 'Card_Portal_Reports_Reports_Schedule_Account_Spend_Summary_by_Location_Run_Report',
    '3': 'Card_Portal_Reports_Reports_Schedule_Account_Transaction_Detail_Report_Run_Report',
    '4': 'Card_Portal_Reports_Reports_Schedule_Account_Transaction_Summary_GST_Run_Report',
    '5': 'Card_Portal_Reports_Reports_Schedule_Account_Transaction_Summary_Report_Run_Report',
    '6': 'Card_Portal_Reports_Reports_Schedule_Card Details_Report_Structure_Run_Report',
    '7': 'Card_Portal_Reports_Reports_Schedule_Card_Details_Report_Run_Report',
    '8': 'Card_Portal_Reports_Reports_Schedule_Card_Summary_Run_Report',
    '9': 'Card_Portal_Reports_Reports_Schedule_Card_Renewal_Run_Report',
    '11': 'Card_Portal_Reports_Reports_Schedule_Exception_Run_Report',
    '15': 'Card_Portal_Reports_Reports_Schedule_Services_and_Repairs_Maintenance_Data_Load_Run_Report',
    '16': 'Card_Portal_Reports_Reports_Schedule_Services_and_ Repairs_Maintenance_Run_Report',
    '18': 'Card_Portal_Reports_Reports_Schedule_Purchases_for_BAS_Run_Report'
  },
  reportHelp: {
    '1': 'Card_Portal_Reports_Account_Fuel_Spend_Summary_Run_Report',
    '2': 'Card_Portal_Reports_Account_Spend_Summary_by_Location_Run_Report',
    '3': 'Card_Portal_Reports_Account_Transaction_Detail_Report_Run_Report',
    '4': 'Card_Portal_Reports_Account_Transaction_Summary_GST_Run_Report',
    '5': 'Card_Portal_Reports_Account_Transaction_Summary_Report_Run_Report',
    '6': 'Card_Portal_Reports_Card Details_Report_Structure_Run_Report',
    '7': 'Card_Portal_Reports_Card_Details_Report_Run_Report',
    '8': 'Card_Portal_Reports_Card_Summary_Run_Report',
    '9': 'Card_Portal_Reports_Card_Renewal_Run_Report',
    '11': 'Card_Portal_Reports_Exception_Run_Report',
    '15': 'Card_Portal_Reports_Services_and_Repairs_Maintenance_Data_Load_Run_Report',
    '16': 'Card_Portal_Reports_Services_and_ Repairs_Maintenance_Run_Report',
    '18': 'Card_Portal_Reports_Purchases_for_BAS_Run_Report'
  }
};

export const gtmReportEvents = (reportTypeId, type) => {
  window.dataLayer.push({
    event: reportScheduleGTMTags[type][reportTypeId],
    button_click: true,
  });
};

export const addEditCardFormOnChangeGTMTags = {
  account: {
    'favourite': 'Card_Portal_Accounts_Cards_Usage_Options_Update',
    'verifyPosPrompt': 'Card_Portal_Accounts_Cards_POS_Prompts',
    'odometerRequired': 'Card_Portal_Accounts_Cards_POS_Prompts',
    'orderNumberRequired': 'Card_Portal_Accounts_Cards_POS_Prompts',
    'monthlyLimit': 'Card_Portal_Accounts_Cards_Purchase_Controls',
    'dailyLimit': 'Card_Portal_Accounts_Cards_Purchase_Controls',
    'allProducts': 'Card_Portal_Accounts_Cards_Products_And_Services',
    '95A': 'Card_Portal_Accounts_Cards_Products_And_Services',
    '98A': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'B/G': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'CWA': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'DIS': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'GDS': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'GNG': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'LPG': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'OIL': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'SRV': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'ULP': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'WRK': 'Card_Portal_Accounts_Cards_Products_And_Services',
    'fuelPay': 'Card_Portal_Accounts_Cards_Value_Added_Services',
    'roadsideAssist': 'Card_Portal_Accounts_Cards_Value_Added_Services',
    'vehicleType': 'Card_Portal_Accounts_Cards_Value_Added_Services',
    'serviceAndRepairs': 'Card_Portal_Accounts_Cards_Value_Added_Services'
  },
  accountFavorites: {
    'favourite': 'Card_Portal_Accounts_Card_Favourites_Usage_Options_Update',
    'verifyPosPrompt': 'Card_Portal_Accounts_Card_Favourites_Edit_POS_Prompts',
    'odometerRequired': 'Card_Portal_Accounts_Card_Favourites_Edit_POS_Prompts',
    'orderNumberRequired': 'Card_Portal_Accounts_Card_Favourites_Edit_POS_Prompts',
    'monthlyLimit': 'Card_Portal_Accounts_Card_Favourites_Edit_Purchase_Controls',
    'dailyLimit': 'Card_Portal_Accounts_Card_Favourites_Edit_Purchase_Controls',
    'allProducts': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    '95A': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    '98A': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'B/G': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'CWA': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'DIS': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'GDS': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'GNG': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'LPG': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'OIL': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'SRV': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'ULP': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'WRK': 'Card_Portal_Accounts_Card_Favourites_Edit_Products_And_Services',
    'fuelPay': 'Card_Portal_Accounts_Card_Favourites_Edit_Value_Added_Services',
    'roadsideAssist': 'Card_Portal_Accounts_Card_Favourites_Edit_Value_Added_Services',
    'vehicleType': 'Card_Portal_Accounts_Card_Favourites_Edit_Value_Added_Services',
    'serviceAndRepairs': 'Card_Portal_Accounts_Card_Favourites_Edit_Value_Added_Services'
  },
  card: {
    'favourite': 'Card_Portal_Individual_Card_Detail_Cards_Usage_Options_Update',
    'verifyPosPrompt': 'Card_Portal_Individual_Card_Detail_Usage_Options_POS_Prompts',
    'odometerRequired': 'Card_Portal_Individual_Card_Detail_Usage_Options_POS_Prompts',
    'orderNumberRequired': 'Card_Portal_Individual_Card_Detail_Usage_Options_POS_Prompts',
    'monthlyLimit': 'Card_Portal_Individual_Card_Detail_Usage_Monthly_Limit',
    'dailyLimit': 'Card_Portal_Individual_Card_Detail_Usage_Daily_Limit',
    'allProducts': 'Card_Portal_Card_Products_And_Services',
    '95A': 'Card_Portal_Card_Products_And_Services',
    '98A': 'Card_Portal_Card_Products_And_Services',
    'B/G': 'Card_Portal_Card_Products_And_Services',
    'CWA': 'Card_Portal_Card_Products_And_Services',
    'DIS': 'Card_Portal_Card_Products_And_Services',
    'GDS': 'Card_Portal_Card_Products_And_Services',
    'GNG': 'Card_Portal_Card_Products_And_Services',
    'LPG': 'Card_Portal_Card_Products_And_Services',
    'OIL': 'Card_Portal_Card_Products_And_Services',
    'SRV': 'Card_Portal_Card_Products_And_Services',
    'ULP': 'Card_Portal_Card_Products_And_Services',
    'WRK': 'Card_Portal_Card_Products_And_Services',
    'fuelPay': 'Card_Portal_Individual_Card_Detail_Usage_Value_Added_Services',
    'roadsideAssist': 'Card_Portal_Individual_Card_Detail_Usage_Value_Added_Services',
    'vehicleType': 'Card_Portal_Individual_Card_Detail_Usage_Value_Added_Services',
    'serviceAndRepairs': 'Card_Portal_Individual_Card_Detail_Usage_Value_Added_Services'
  },
  newCard: {
    'favourite': 'Card_Portal_Add_New_Card_Card_Usage_Favourite',
    'verifyPosPrompt': 'Card_Portal_Add_New_Card_Card_Usage_Options_POS_Prompts',
    'odometerRequired': 'Card_Portal_Add_New_Card_Odometer_Required',
    'orderNumberRequired': 'Card_Portal_Add_New_Card_Order_Number_Required',
    'monthlyLimit': 'Card_Portal_Add_New_Card_Monthly_Limit',
    'dailyLimit': 'Card_Portal_Add_New_Card_Daily_Limit',
    'allProducts': 'Card_Portal_Add_New_Card_Products_And_Services',
    '95A': 'Card_Portal_Add_New_Card_Products_And_Services',
    '98A': 'Card_Portal_Add_New_Card_Products_And_Services',
    'B/G': 'Card_Portal_Add_New_Card_Products_And_Services',
    'CWA': 'Card_Portal_Add_New_Card_Products_And_Services',
    'DIS': 'Card_Portal_Add_New_Card_Products_And_Services',
    'GDS': 'Card_Portal_Add_New_Card_Products_And_Services',
    'GNG': 'Card_Portal_Add_New_Card_Products_And_Services',
    'LPG': 'Card_Portal_Add_New_Card_Products_And_Services',
    'OIL': 'Card_Portal_Add_New_Card_Products_And_Services',
    'SRV': 'Card_Portal_Add_New_Card_Products_And_Services',
    'ULP': 'Card_Portal_Add_New_Card_Products_And_Services',
    'WRK': 'Card_Portal_Add_New_Card_Products_And_Services',
    'fuelPay': 'Card_Portal_Add_New_Card_Value_Added_Services',
    'roadsideAssist': 'Card_Portal_Add_New_Card_Value_Added_Services',
    'vehicleType': 'Card_Portal_Add_New_Card_Value_Added_Services',
    'serviceAndRepairs': 'Card_Portal_Add_New_Card_Value_Added_Services'
  }
};

export const gtmFormOnChangeEvents = (name, values, modalType) => {
  const type = modalType ? modalType : 'card';
  if (name === 'favourite') {
    window.dataLayer.push({
      event: addEditCardFormOnChangeGTMTags[type][name],
      favourite: values[name],
    });
  }
  if (name === 'verifyPosPrompt') {
    window.dataLayer.push({
      event: addEditCardFormOnChangeGTMTags[type][name],
      selected: values[name],
    });
  }
  if (name === 'odometerRequired') {
    window.dataLayer.push({
      event: addEditCardFormOnChangeGTMTags[type][name],
      odometer_required: values[name],
    });
  }
  if (name === 'orderNumberRequired') {
    window.dataLayer.push({
      event: addEditCardFormOnChangeGTMTags[type][name],
      order_number_required: values[name],
    });
  }
  if (name === 'monthlyLimit') {
    window.dataLayer.push({
      event: addEditCardFormOnChangeGTMTags[type][name],
      monthly_limit: values[name],
    });
  }
  if (name === 'dailyLimit') {
    window.dataLayer.push({
      event: addEditCardFormOnChangeGTMTags[type][name],
      daily_limit: values[name],
    });
  }
  if (name === 'allProducts') {
    window.dataLayer.push({
      event: addEditCardFormOnChangeGTMTags[type][name],
      services_selected: name,
      [name]: values[name]
    });
  }
  if (name === '95A' || name === '98A' || name === 'B/G' || name === 'CWA' ||
    name === 'DIS' || name === 'GDS' || name === 'GNG' || name === 'LPG' || name === 'OIL' ||
    name === 'SRV' || name === 'ULP' || name === 'WRK') {
    const fleetLimiterArray = values.fleetLimiters;
    if (fleetLimiterArray) {
      const filteredArray = fleetLimiterArray && fleetLimiterArray.filter((item) => item.code === name);
      const selectedService = filteredArray && filteredArray[0].desc;
      window.dataLayer.push({
        event: addEditCardFormOnChangeGTMTags[type][name],
        services_selected: selectedService,
        [selectedService]: values[name],
      });
    } else {
      window.dataLayer.push({
        event: addEditCardFormOnChangeGTMTags[type][name],
        services_selected: name,
        [name]: values[name]
      });
    }
  }
  if (name === 'fuelPayApp' || name === 'roadsideAssist' || name === 'vehicleType' || name === 'serviceAndRepairs') {
    window.dataLayer.push({
      event: addEditCardFormOnChangeGTMTags[type][name],
      services_selected: name,
      [name]: values[name]
    });
  }
};